export const SOLUTION_DEMO_REGION_OPTIONS = [
  { label: 'All Regions', value: 'All' },
  { label: 'APJ', value: 'APJ' },
  { label: 'EMEA', value: 'EMEA' },
  { label: 'NA', value: 'NA' },
  { label: 'LATAM', value: 'LATAM' },
];

export const SOLUTION_DEMO_ORG_OPTIONS = [
  { label: 'All Orgs', value: 'All' },
  { label: 'Partner', value: 'Partner' },
  { label: 'VSE', value: 'VSE' },
  { label: 'Customer Success', value: 'Customer Success' },
  { label: 'PAE', value: 'PAE' },
];

export const SOLUTION_DEMO_CERTIFICATION_OPTIONS = [
  { label: 'All Statuses', value: 'All' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Missing Capstone', value: 'Missing Capstone' },
  { label: 'Pending Capstone Review', value: 'Pending Capstone Review' },
  { label: 'Registered', value: 'Registered' },
  { label: 'Failed', value: 'Failed' },
  { label: 'No Show', value: 'No Show' },
];

export const SOLUTION_DEMO_BOOTCAMP_OPTIONS = [
  { label: 'All Bootcamps', value: 'All' },
  { label: 'Solution Demo', value: 'Solution Demo' },
];

export const SOLUTION_DEMO_ATTENDANCE_OPTIONS = [
  { label: 'Attendance: All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'N/D', value: 'N/D' },
];

const toUniqueList = (values) =>
  [...new Set((Array.isArray(values) ? values : []).map((value) => String(value || '').trim()).filter(Boolean))];

const sortAlphabetically = (values) => [...values].sort((a, b) => a.localeCompare(b));

export const STABLE_FILTER_OPTION_VALUES = {
  bootcampNames: SOLUTION_DEMO_BOOTCAMP_OPTIONS.filter((item) => item.value !== 'All').map(
    (item) => item.value
  ),
  regions: SOLUTION_DEMO_REGION_OPTIONS.filter((item) => item.value !== 'All').map((item) => item.value),
  orgs: SOLUTION_DEMO_ORG_OPTIONS.filter((item) => item.value !== 'All').map((item) => item.value),
  certifications: SOLUTION_DEMO_CERTIFICATION_OPTIONS.filter((item) => item.value !== 'All').map(
    (item) => item.value
  ),
  attendanceValues: SOLUTION_DEMO_ATTENDANCE_OPTIONS.filter((item) => item.value !== 'All').map(
    (item) => item.value
  ),
  cohorts: [],
  champions: [],
};

export const buildStableFilterOptions = ({ cohorts = [], champions = [] } = {}) => ({
  bootcampNames: STABLE_FILTER_OPTION_VALUES.bootcampNames,
  regions: STABLE_FILTER_OPTION_VALUES.regions,
  orgs: STABLE_FILTER_OPTION_VALUES.orgs,
  certifications: STABLE_FILTER_OPTION_VALUES.certifications,
  attendanceValues: STABLE_FILTER_OPTION_VALUES.attendanceValues,
  cohorts: sortAlphabetically(toUniqueList(cohorts)),
  champions: sortAlphabetically(toUniqueList(champions)),
});

export const extractCohortOptions = (bootcampStats = {}) => {
  const fromFilterOptions = toUniqueList(bootcampStats?.filterOptions?.cohorts);
  if (fromFilterOptions.length > 0) {
    return sortAlphabetically(fromFilterOptions);
  }

  const fromOutcomes = toUniqueList(
    (bootcampStats?.certificationOutcomesByCohort || []).map((item) => item?.cohort ?? item?.cohortLabel)
  );
  const fromTrends = toUniqueList(
    (bootcampStats?.certificationTrendsByCohort || []).map((item) => item?.cohort ?? item?.cohortLabel)
  );

  return sortAlphabetically([...new Set([...fromOutcomes, ...fromTrends])]);
};

export const extractChampionOptions = (participants = {}) => {
  const fromFilterOptions = toUniqueList(participants?.filterOptions?.champions);
  if (fromFilterOptions.length > 0) {
    return sortAlphabetically(fromFilterOptions);
  }

  return sortAlphabetically(
    toUniqueList((participants?.records || []).map((item) => item?.bmcHelixChampion ?? item?.champion))
  );
};
